import { on } from '@ember/modifier';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import trueStringIfPresent from 'volta/helpers/true-string-if-present';
import BvCheckbox from 'volta/components/bv-checkbox';
import type { TOC } from '@ember/component/template-only';

interface BvResourceListCheckableBtnSignature {
  Args: {
    accessibilityLabel?: string;
    disabled?: boolean;
    label?: string;
    measuring?: boolean;
    onToggleAll?: () => void;
    plain?: boolean;
    selectMode?: boolean;
    selected?: boolean;
  };
  Element: HTMLDivElement;
}

const BvResourceListCheckableBtnComponent: TOC<BvResourceListCheckableBtnSignature> = <template>
  {{! template-lint-disable require-presentational-children }}
  <div
    class='bv-resource-list-checkable-btn'
    role='button'
    data-plain={{trueStringIfPresent @plain}}
    data-select-mode={{trueStringIfPresent @selectMode}}
    data-selected={{trueStringIfPresent @selected}}
    data-measuring={{trueStringIfPresent @measuring}}
    ...attributes
    {{on 'click' (optional @onToggleAll)}}
  >
    <div class='bv-resource-list-checkable-btn__checkbox'>
      <BvCheckbox
        @label={{@accessibilityLabel}}
        @labelHidden={{true}}
        @checked={{@selected}}
        @disabled={{@disabled}}
      />
    </div>
    <span class='bv-resource-list-checkable-btn__label'>
      {{@label}}
    </span>
  </div>
</template>;

export default BvResourceListCheckableBtnComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvResourceList::CheckableBtn': typeof BvResourceListCheckableBtnComponent;
    'bv-resource-list/checkable-btn': typeof BvResourceListCheckableBtnComponent;
  }
}
